module.exports = __webpack_public_path__ + "img/share.d1b2fec5.svg";